import { z } from 'zod';

export const legalPersonSchema = z.object({
  idBusinessForm: z.number().int(),

  FirstName: z.string().min(1, 'Vorname ist erforderlich'),
  Birthdate: z.string().nullable(),
  Birthplace: z.string().nullable(),
  TaxNumber: z.string().nullable(),
  SalesTaxNumber: z.string().nullable(),
  Email: z.string().nullable(),
  DateOfDeath: z.string().nullable(),
  PlaceOfDeath: z.string().nullable(),
});

export type ILegalPerson = z.infer<typeof legalPersonSchema>;
